import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function Recipients() {
  const [recipients, setRecipients] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    axios.get('/api/admin/recipients')
      .then(r => setRecipients(r.data))
      .catch(() => setErr('Failed to load recipients'))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const add = async () => {
    if (!newEmail.trim()) { setErr('Enter an email address'); return; }
    setErr(''); setMsg('');
    try {
      const r = await axios.post('/api/admin/recipients', { email: newEmail.trim() });
      setRecipients(prev => [...prev, r.data]);
      setNewEmail('');
      setMsg('Recipient added.');
    } catch (e) { setErr(e.response?.data?.error || 'Failed to add'); }
  };

  const remove = async (id, email) => {
    if (!window.confirm(`Remove ${email}?`)) return;
    setErr(''); setMsg('');
    try {
      await axios.delete(`/api/admin/recipients/${id}`);
      setRecipients(prev => prev.filter(r => r.id !== id));
      setMsg('Recipient removed.');
    } catch (e) { setErr(e.response?.data?.error || 'Failed to remove'); }
  };

  return (
    <div>
      <div className="admin-card">
        <h2>Recipient Email Addresses</h2>
        <p style={{ fontSize: 14, color: 'var(--text-light)', marginBottom: 16 }}>
          All driver applications will be sent to every address listed here.
        </p>
        <div className="admin-input-row">
          <input className="admin-input" value={newEmail} onChange={e => setNewEmail(e.target.value)}
            placeholder="new@email.com" type="email" onKeyDown={e => e.key === 'Enter' && add()} />
          <button className="btn-primary" onClick={add}>Add</button>
        </div>
        {err && <div className="field-error" style={{ marginBottom: 8 }}>{err}</div>}
        {msg && <div style={{ color: 'var(--success)', fontSize: 14, marginBottom: 8 }}>{msg}</div>}
      </div>
      <div className="admin-card">
        {loading ? <p>Loading...</p> : (
          <table className="admin-table">
            <thead><tr><th>Email</th><th>Action</th></tr></thead>
            <tbody>
              {recipients.length === 0 ? (
                <tr><td colSpan={2} style={{ color: 'var(--text-light)', textAlign: 'center' }}>No recipients configured</td></tr>
              ) : recipients.map(r => (
                <tr key={r.id}>
                  <td>{r.email}</td>
                  <td><button className="btn-danger" onClick={() => remove(r.id, r.email)}>Remove</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
